module.exports = __webpack_public_path__ + "static/media/feature-promote.b9010422.png";